:host {
  @apply block;
}

// scales
:host([scale="s"]) {
  & input,
  & .prefix,
  & .suffix {
    @apply text-n2h h-6 px-2;
  }
  & textarea {
    @apply h-6;
    min-block-size: theme("spacing.6");
  }
  & .number-button-wrapper,
  & .action-wrapper calcite-button,
  & .action-wrapper calcite-button button {
    @apply h-6;
  }
  & input[type="file"] {
    @apply h-6;
  }
  & .clear-button {
    min-block-size: theme("spacing.6");
    min-inline-size: theme("spacing.6");
  }
  & textarea {
    @apply text-n2h
    h-auto
    py-1
    px-2;
  }
}

:host([scale="m"]) {
  & input,
  & .prefix,
  & .suffix {
    @apply text-n1h h-8 px-3;
  }
  & textarea {
    min-block-size: theme("spacing.8");
  }
  & .number-button-wrapper,
  & .action-wrapper calcite-button,
  & .action-wrapper calcite-button button {
    @apply h-8;
  }
  & input[type="file"] {
    @apply h-8;
  }
  & .clear-button {
    min-block-size: theme("spacing.8");
    min-inline-size: theme("spacing.8");
  }
  & textarea {
    @apply text-n1h
      h-auto
      py-2
      px-3;
  }
}

:host([scale="l"]) {
  & input,
  & .prefix,
  & .suffix {
    @apply text-0h h-11 px-4;
  }
  & textarea {
    min-block-size: theme("spacing.11");
  }
  & .number-button-wrapper,
  & .action-wrapper calcite-button,
  & .action-wrapper calcite-button button {
    @apply h-11;
  }
  & input[type="file"] {
    @apply h-11;
  }
  & .clear-button {
    min-block-size: theme("spacing.11");
    min-inline-size: theme("spacing.11");
  }
  & textarea {
    @apply text-0h
      h-auto
      py-3
      px-4;
  }
}

@include disabled() {
  & textarea {
    resize: none;
  }
}

textarea,
input {
  transition: var(--calcite-animation-timing), block-size 0, outline-offset 0s;
  -webkit-appearance: none;
  @apply font-inherit
    text-color-1
    bg-foreground-1
    relative
    m-0
    box-border
    flex
    max-h-full
    w-full
    max-w-full
    flex-1
    rounded-none
    font-normal;
}

input[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}

// states
input,
textarea {
  @apply border
    border-color-input
    border-solid
    text-color-1
    text-ellipsis;
  &::placeholder,
  &:-ms-input-placeholder,
  &::-ms-input-placeholder {
    @apply text-color-3 font-normal;
  }
  &:placeholder-shown {
    @apply text-ellipsis;
  }
}
input:focus,
textarea:focus {
  @apply border-color-brand text-color-1;
}
input[readonly],
textarea[readonly] {
  @apply bg-background font-medium;
}
input[readonly]:focus,
textarea[readonly]:focus {
  @apply text-color-1;
}
calcite-icon {
  @apply text-color-3;
}

//focus
textarea,
input {
  @apply focus-base;
}
textarea:focus,
input:focus {
  @apply focus-inset;
}

:host([status="invalid"]) {
  & input,
  & textarea {
    @apply border-color-danger;
  }
  & input:focus,
  & textarea:focus {
    @apply focus-inset-danger;
  }
}

// ICONS

// position icons

:host([scale="s"]) .icon {
  inset-inline-start: theme("spacing.2");
}

:host([scale="m"]) .icon {
  inset-inline-start: theme("spacing.3");
}

:host([scale="l"]) .icon {
  inset-inline-start: theme("spacing.4");
}

// position placeholder/value text in relation to icons

:host([icon][scale="s"]) input {
  padding-inline-start: theme("padding.8");
}

:host([icon][scale="m"]) input {
  padding-inline-start: theme("padding.10");
}

:host([icon][scale="l"]) input {
  padding-inline-start: theme("padding.14");
}

// positioning wrapper for icon and loader

.element-wrapper {
  @apply relative
    order-3
    inline-flex
    flex-1
    items-center;
}

.icon {
  @apply transition-default
    pointer-events-none
    absolute
    block;
}

.icon,
.resize-icon-wrapper {
  @apply z-default; // needed for firefox to display the icon properly
}

// hide browser default clear

input[type="text"]::-ms-clear,
input[type="text"]::-ms-reveal {
  @apply hidden
    h-0
    w-0;
}
input[type="search"]::-webkit-search-decoration,
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-results-button,
input[type="search"]::-webkit-search-results-decoration,
input[type="date"]::-webkit-clear-button,
input[type="time"]::-webkit-clear-button {
  @apply hidden;
}

.clear-button {
  pointer-events: initial;
  @apply focus-base
    border-color-input
    bg-foreground-1
    order-4
    m-0
    box-border
    flex
    min-h-full
    cursor-pointer
    items-center
    justify-center
    self-stretch
    border
    border-solid;

  border-inline-start-width: theme("borderWidth.0");

  &:hover {
    @apply bg-foreground-2 transition-default;
    calcite-icon {
      @apply text-color-1 transition-default;
    }
  }
  &:active {
    @apply bg-foreground-3;
    calcite-icon {
      @apply text-color-1;
    }
  }
  &:focus {
    @apply focus-inset;
  }
  &:disabled {
    @apply opacity-disabled;
  }
}

// loading
.loader {
  inset-block-start: 1px;
  inset-inline: 1px;
  @apply pointer-events-none
    absolute
    block;
}

// slotted action
.action-wrapper {
  @apply order-7 flex;
}

// prefix and suffix
.prefix,
.suffix {
  @apply border-color-input
    bg-background
    text-color-2
    box-border
    flex
    h-auto
    min-h-full
    select-none
    content-center
    items-center
    break-words
    border
    border-solid
    font-medium
    leading-none;
}

.prefix {
  @apply order-2;
  border-inline-end-width: theme("borderWidth.0");
}
.suffix {
  @apply order-5;
  border-inline-start-width: theme("borderWidth.0");
}

// alignment type
:host([alignment="start"]) {
  & textarea,
  & input {
    text-align: start;
  }
}

:host([alignment="end"]) {
  & textarea,
  & input {
    text-align: end;
  }
}

// number buttons
input[type="number"] {
  -moz-appearance: textfield;

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    -moz-appearance: textfield;
    @apply m-0;
  }
}

.number-button-wrapper {
  @apply transition-default
    pointer-events-none
    order-6
    box-border
    flex
    flex-col;
}

:host([number-button-type="vertical"]) .wrapper {
  flex-direction: row;
  display: flex;
}

:host([number-button-type="vertical"]) {
  & input,
  textarea {
    @apply order-2;
  }
}

:host([number-button-type="horizontal"]) .calcite--rtl {
  & .number-button-item[data-adjustment="down"] calcite-icon {
    transform: rotate(-90deg);
  }
  & .number-button-item[data-adjustment="up"] calcite-icon {
    transform: rotate(-90deg);
  }
}

.number-button-item.number-button-item--horizontal {
  &[data-adjustment="down"],
  &[data-adjustment="up"] {
    @apply order-1
      max-h-full
      min-h-full
      self-stretch;
    & calcite-icon {
      transform: rotate(90deg);
    }
  }
}

.number-button-item.number-button-item--horizontal[data-adjustment="down"] {
  @apply border-color-input
    border
    border-solid;
  border-inline-end-width: theme("borderWidth.0");
  &:hover {
    @apply bg-foreground-2;
    calcite-icon {
      @apply text-color-1;
    }
  }
}

.number-button-item.number-button-item--horizontal[data-adjustment="up"] {
  @apply order-5;
  &:hover {
    @apply bg-foreground-2;
    calcite-icon {
      @apply text-color-1;
    }
  }
}

:host([number-button-type="vertical"]) .number-button-item[data-adjustment="down"]:hover {
  @apply bg-foreground-2;
  calcite-icon {
    @apply text-color-1;
  }
}

:host([number-button-type="vertical"]) .number-button-item[data-adjustment="up"]:hover {
  @apply bg-foreground-2;
  calcite-icon {
    @apply text-color-1;
  }
}

:host([number-button-type="vertical"]) .number-button-item[data-adjustment="down"] {
  @apply border-t-0;
}

.number-button-item {
  max-block-size: 50%;
  min-block-size: 50%;
  pointer-events: initial;
  @apply border-color-input
    bg-foreground-1
    transition-default
    m-0
    box-border
    flex
    cursor-pointer
    items-center
    self-center
    border
    border-solid
    py-0
    px-2;
  border-inline-start-width: theme("borderWidth.0");
  & calcite-icon {
    @apply transition-default pointer-events-none;
  }
  &:focus {
    @apply bg-foreground-2;
    calcite-icon {
      @apply text-color-1;
    }
  }
  &:active {
    @apply bg-foreground-3;
  }
  &:disabled {
    @apply pointer-events-none;
  }
}

.wrapper {
  @apply relative
    flex
    flex-row
    items-center;
}

// hide the default date picker
:input::-webkit-calendar-picker-indicator {
  @apply hidden;
}

input[type="date"]::-webkit-input-placeholder {
  visibility: hidden !important;
}

// textarea resize icon
textarea::-webkit-resizer {
  @apply absolute
    bottom-0
    box-border
    py-0
    px-1;
  inset-inline-end: 0;
}

.resize-icon-wrapper {
  inset-block-end: 2px;
  inset-inline-end: 2px;

  @apply bg-foreground-1
    text-color-3
    pointer-events-none
    absolute
    h-3
    w-3;

  & calcite-icon {
    inset-block-end: theme("spacing.1");
    inset-inline-end: theme("spacing.1");
    transform: rotate(-45deg);
  }
}

.calcite--rtl {
  .resize-icon-wrapper {
    & calcite-icon {
      transform: rotate(45deg);
    }
  }
}

:host([type="color"]) input {
  @apply p-1;
}

// file input
:host([type="file"]) input {
  @apply bg-foreground-1
    border-color-input
    cursor-pointer
    border
    border-dashed
    text-center;
}

:host([type="file"][scale="s"]) input {
  @apply py-px px-2;
}

:host([type="file"][scale="m"]) input {
  @apply py-1 px-3;
}

:host([type="file"][scale="l"]) input {
  @apply py-2 px-4;
}

:host(.no-bottom-border) input {
  @apply border-b-0;
}

:host(.border-top-color-one) input {
  @apply border-t-color-1;
}

// input needed for higher specificity of these overrides
input {
  &.inline-child {
    @apply transition-default bg-transparent;
    .editing-enabled {
      background-color: inherit;
    }
  }

  &.inline-child:not(.editing-enabled) {
    @apply border-color-transparent
      flex
      cursor-pointer text-ellipsis;
    padding-inline-start: 0;
  }
}

@include form-validation-message();
@include hidden-form-input();
@include base-component();
